import { render, staticRenderFns } from "./imgClass.vue?vue&type=template&id=43be608f&scoped=true"
import script from "./imgClass.vue?vue&type=script&lang=js"
export * from "./imgClass.vue?vue&type=script&lang=js"
import style0 from "./imgClass.vue?vue&type=style&index=0&id=43be608f&prod&lang=scss"
import style1 from "./imgClass.vue?vue&type=style&index=1&id=43be608f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43be608f",
  null
  
)

export default component.exports